import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saDataRetainabilityPer5QiChartConfig } from '../chartConfigs';

interface DataRetainabilityPer5QiSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataRetainabilityPer5QiSaEcharts: React.FC<DataRetainabilityPer5QiSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saDataRetainabilityPer5QiChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default DataRetainabilityPer5QiSaEcharts;
